export const emptyArray = [];
export const toAbsoluteUrl = pathname => window.location.origin + pathname;